import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog) {}

  closeDialog(): void {
    this.dialogRef.close();
  }

  closeAndReopenFirstModal(parentDialogRef: MatDialogRef<any>): void {
    this.dialogRef.close();

    setTimeout(() => {
      parentDialogRef.close();
    }, 200);

    setTimeout(() => {
      this.dialog.open(ConfirmDialogComponent, {
        width: '500px',
        height: 'auto',
        maxHeight: '300px',
        autoFocus: false,
        data: { message: 'Reabrindo o primeiro modal' },
        panelClass: 'first-dialog'
      });
    }, 400);
  }
}
